///ts-nocheck
import config from "./Api-config";
import storage from "@/storage/storage";

class SignalGo {
  conn: WebSocket;
  id = null;
  connected = false;
  options = {
    url: config.ST_WEBSOCKET_PUBSUB,
    autoRetry: true,
    //autoRetryInMs:1000*60*10,
    autoRetryInMs: 1000,
  };
  events = {};
  agentRequests: { [topic: string]: Map<string, { cb: (d: any) => void; settle: () => void; timer: any }> } = {};
  OnClose: any = null;
  OnError: any = null;
  OnConnected: any = null;
  keepaliveTimer: ReturnType<typeof setInterval> | null = null;
  readonly KEEPALIVE_MS = 9 * 60 * 1000;
  log = {
    i(msg) {
      console.info("SignalGo", msg);
    },
    e(msg) {
      console.error("SignalGo", msg);
    },
    d(msg) {
      console.debug("SignalGo", msg);
    }
  };

  async Connect(opts) {
    const options = this.options;
    this.options = {
      ...options,
      ...opts
    };
    await this.doConnect();
  }

  async reConnect() {
    if (this.options.autoRetry) {
      setTimeout(async () => {
        if (this.conn.readyState == WebSocket.CLOSED) {
          await this.doConnect();
        }
      }, this.options.autoRetryInMs);
    }
  }

  async doConnect() {
    if (!this.connected) {
      let tokenParam = "";
      const token = await storage.getItem(config.STORAGE_KEYS.TOKEN);
      if (token) {
        tokenParam = `?token=${token}`;
      }

      if (this.conn) {
        this.conn.onclose = null;
        this.conn.onerror = null;
        this.conn.onopen = null;
        this.conn.onmessage = null;
      }
      const conn = new WebSocket(`wss://${this.options.url + tokenParam}`);
      conn.onclose = async (ev) => {
        this.stopKeepalive();
        this.log.e("On Close: " + ev);
        this.connected = false;
        if (this.OnClose) {
          this.OnClose(ev);
        }
        await this.reConnect();
      };

      conn.onmessage = (ev) => {
        const payload = JSON.parse(ev.data);
        if (payload.event) {
          const callBack = this.events[payload.event];
          if (callBack) {
            callBack(payload);
          }
          this.dispatchAgentResponse(payload.event, payload);
        }
        this.log.i(ev);
      };
      conn.onerror = (ev) => {
        this.stopKeepalive();
        this.log.e("On Error: " + ev);
        this.connected = false;
        if (this.OnError) {
          this.OnError(ev);
        }

        this.reConnect();
      };
      conn.onopen = (ev) => {
        this.log.i("Connected: " + ev);
        this.connected = true;
        if (this.OnConnected) {
          this.OnConnected(ev);
        }
        Object.keys(this.events).forEach(key => {
          this.registerEvent(key);
        });
        this.startKeepalive();
      };
      this.conn = conn;
    }
  }

  registerEvent(key) {
    const payload = {
      "t": 2,
      "e": key
    };
    this.doSend(payload, "Error on event registration!");
  }

  Unsubscribe(key) {
    const payload = {
      "t": 3,
      "e": key
    };
    this.doSend(payload, "Error on event unregister!");
    delete this.events[key];
  }

  Subscribe(ev, callback) {
    this.On(ev, callback);
  }

  On(ev, callBack) {
    this.events[ev] = callBack;
    if (this.connected) {
      this.registerEvent(ev);
    }
  }

  dispatchAgentResponse(ev, data) {
    const pending = this.agentRequests[ev];
    if (!pending || pending.size === 0) return;
    let content;
    try {
      content = typeof data.content === "string" ? JSON.parse(data.content) : data.content;
    } catch (e) {
      this.log.e("AgentRequest: failed to parse response content: " + e);
      return;
    }
    if (!content || (content.Success !== true && content.Success !== false)) return;
    const entry = content.Str ? pending.get(content.Str) : undefined;
    if (!entry) return;
    clearTimeout(entry.timer);
    pending.delete(content.Str);
    this.cleanupAgentTopic(ev);
    entry.cb({ ...data, content });
    entry.settle();
  }

  cleanupAgentTopic(ev) {
    const pending = this.agentRequests[ev];
    if (pending && pending.size === 0) {
      delete this.agentRequests[ev];
      if (!this.events[ev]) {
        this.Unsubscribe(ev);
      }
    }
  }

  doSend(payload, err, force?) {
    if (!this.connected && !force) {
      console.error(err);
      return;
    }
    //let buff=this.str2ab(JSON.stringify(payload))
    this.conn.send(JSON.stringify(payload));
  }

  Send(ev, message) {
    const payload = {
      "t": 1,
      "m": message,
      "e": ev
    };
    this.doSend(payload, "Can't send message if connection is not established yet!");
  }
  startKeepalive() {
    this.stopKeepalive();
    this.keepaliveTimer = setInterval(() => {
      if (this.conn?.readyState === WebSocket.OPEN) {
        this.conn.send(JSON.stringify({ t: 9, e: "keepalive" }));
      }
    }, this.KEEPALIVE_MS);
  }
  stopKeepalive() {
    if (this.keepaliveTimer) {
      clearInterval(this.keepaliveTimer);
      this.keepaliveTimer = null;
    }
  }
  PingWSServer() {
    this.startKeepalive();
  }
  StopPing() {
    // no-op: keepalive is lifecycle-managed and must outlive the NFC dialog that calls this
  }
  async AgentRequest(ev, py, cb) {
    const AGENT_TIMEOUT_MS = 30000;
    const reqStr = (window?.crypto as any)?.randomUUID?.() ??
      (Math.random() + 1).toString(36).substring(7) + Date.now().toString(36);
    const payload = JSON.parse(py);
    payload.Str = reqStr;
    payload.e = ev;

    return new Promise(resolve => {
      const pending = this.agentRequests[ev] ?? (this.agentRequests[ev] = new Map());
      const firstForTopic = pending.size === 0;

      let settled = false;
      const settle = () => {
        if (settled) return;
        settled = true;
        resolve(true);
      };

      const timer = setTimeout(() => {
        if (!pending.has(reqStr)) return;
        pending.delete(reqStr);
        this.cleanupAgentTopic(ev);
        cb({ content: { Success: false, Message: "No response from Agent Server after 30 seconds" } });
        settle();
      }, AGENT_TIMEOUT_MS);

      pending.set(reqStr, { cb, settle, timer });

      if (firstForTopic && !this.events[ev]) {
        this.registerEvent(ev);
      }

      this.Send(ev, JSON.stringify(payload));
    });
  }
}

const signalGo = new SignalGo();
signalGo.Connect({});
export default signalGo;
